import { reducerWithInitialState } from 'typescript-fsa-reducers/dist';
import { loadedSelfEvalResponses, loadedBugReports, updateSelfEvalResponse, goToTeacherHomeFromAdmin, updateBugReport } from '../actions/admin-ui-actions';
import { BugReport, BugReportStatus, SelfEvalResponse, SelfEvalStatus } from '../../types/admin';
import { ReducerFn } from '../../../../its-pages/src/utils/redux/reducers/types';
import { List } from 'immutable';

type AdminUiReducer<P> = ReducerFn<AdminUIState, P>;

export interface AdminUIState {
  redirectToTeacherHome: boolean;
  selfEvalResponses: List<SelfEvalResponse>;
  bugReports: List<BugReport>;
}

const INITIAL_STATE: AdminUIState = {
    redirectToTeacherHome: false,
    selfEvalResponses: List([]),
    bugReports: List([])
};

const loadedSelfEvalReducer: AdminUiReducer<SelfEvalResponse[]> = (state, payload) => {
    return {
        ...state,
        selfEvalResponses: List(payload)
    }
};

const updateSelfEvalResponseReducer: AdminUiReducer<{id: string, status: SelfEvalStatus}> = (state, payload) => {
    const target = state.selfEvalResponses.find((value) => value.id === payload.id);
    if (target) {
        target.status = payload.status;
    }
    return state;
};

const loadedBugReportsReducer: AdminUiReducer<BugReport[]> = (state, payload) => {
    return {
        ...state,
        bugReports: List(payload)
    };
};

const updateBugReportReducer: AdminUiReducer<{id: string, status: BugReportStatus}> = (state, {id, status}) => {
    const index = state.bugReports.findIndex((value) => value.id === id);
    if (index >= 0 && status !== BugReportStatus.Open) {
        return {
            ...state,
            bugReports: state.bugReports.delete(index)
        };
    }
    return state;
};

const goToTeacherReducer: AdminUiReducer<void> = (state) => {
    return {
        ...state,
        redirectToTeacherHome: true
    };
};

export const adminUIReducers = reducerWithInitialState(INITIAL_STATE)
  .case(loadedSelfEvalResponses, loadedSelfEvalReducer)
  .case(updateSelfEvalResponse, updateSelfEvalResponseReducer)
  .case(loadedBugReports, loadedBugReportsReducer)
  .case(updateBugReport, updateBugReportReducer)
  .case(goToTeacherHomeFromAdmin, goToTeacherReducer)
  .build();
